<div class="m-space-md">
  <div class="justify-end g-space-sm align-center">
    <div class="d-flex">
      <cam-communication-participants-list
        [conversationParticipants]="this.conversationParticipants()"
      ></cam-communication-participants-list>
    </div>
    <cam-font-icon name="filter" type="xs" (click)="this.open = !this.open"></cam-font-icon>
  </div>

  @if (this.open) {
    <div class="flex-row g-space-md">
      @if (this.participantsInput) {
        <cam-input-choices [input]="this.participantsInput"></cam-input-choices>
      }
      @if (this.typeInput) {
        <cam-input-dropdown [input]="this.typeInput"></cam-input-dropdown>
      }
    </div>
  }
</div>

<ng-template #participantTemplate let-item="item" [typedTemplate]="this.participantToken">
  <div class="flex-row align-center g-space-sm">
    <cam-user-logo
      [userInfo]="{
        profilePictureUrl: item.picture,
        naming: {
          firstName: item.firstName,
          name: item.lastName,
          trigram: item.trigram,
        },
      }"
      size="md"
      defaultType="trigram"
    ></cam-user-logo>
    {{ item.firstName }} {{ item.lastName }}
  </div>
</ng-template>

<ng-template #typeTemplate let-item="item" [typedTemplate]="this.participantToken">
  <div class="flex-row align-center g-space-sm">
    <cam-user-logo
      [userInfo]="{
        profilePictureUrl: item.picture,
        naming: {
          firstName: item.firstName,
          name: item.lastName,
          trigram: item.trigram,
        },
      }"
      size="md"
      defaultType="trigram"
    ></cam-user-logo>
    {{ item.firstName }} {{ item.lastName }}
  </div>
</ng-template>
